import { CALL_SELF_SERVE_API } from "middleware/selfServeApi";

export const SET_NEW_ESTIMATION = 'SET_NEW_ESTIMATION';

export const GET_ESTIMATES_REQUEST = 'GET_ESTIMATES_REQUEST';
export const GET_ESTIMATES_SUCCESS = 'GET_ESTIMATES_SUCCESS';
export const GET_ESTIMATES_FAILURE = 'GET_ESTIMATES_FAILURE';

export const POST_ESTIMATE_REQUEST = 'POST_ESTIMATE_REQUEST';
export const POST_ESTIMATE_SUCCESS = 'POST_ESTIMATE_SUCCESS';
export const POST_ESTIMATE_FAILURE = 'POST_ESTIMATE_FAILURE';

export const UPDATE_ESTMATE_REQUEST = 'UPDATE_ESTMATE_REQUEST';
export const UPDATE_ESTIMATE_SUCCESS = 'UPDATE_ESTIMATE_SUCCESS';
export const UPDATE_ESTIMATE_FAILURE = 'UPDATE_ESTIMATE_FAILURE';

export const DELETE_ESTIMATE_REQUEST = 'DELETE_ESTIMATE_REQUEST';
export const DELETE_ESTIMATE_SUCCESS = 'DELETE_ESTIMATE_SUCCESS';
export const DELETE_ESTIMATE_FAILURE = 'DELETE_ESTIMATE_FAILURE';

export const GET_HOMESALE_PRICE_REQUEST = 'GET_HOMESALE_PRICE_REQUEST';
export const GET_HOMESALE_PRICE_SUCCESS = 'GET_HOMESALE_PRICE_SUCCESS';
export const GET_HOMESALE_PRICE_FAILURE = 'GET_HOMESALE_PRICE_FAILURE';

export const GET_FLIGHT_PRICE_REQUEST = 'GET_FLIGHT_PRICE_REQUEST';
export const GET_FLIGHT_PRICE_SUCCESS = 'GET_FLIGHT_PRICE_SUCCESS';
export const GET_FLIGHT_PRICE_FAILURE = 'GET_FLIGHT_PRICE_FAILURE';

export const GET_POLICIES_REQUEST = 'GET_POLICIES_REQUEST';
export const GET_POLICIES_SUCCESS = 'GET_POLICIES_SUCCESS';
export const GET_POLICIES_FAILURE = 'GET_POLICIES_FAILURE';

export const POST_POLICIES_REQUEST = 'POST_POLICIES_REQUEST';
export const POST_POLICIES_SUCCESS = 'POST_POLICIES_SUCCESS';
export const POST_POLICIES_FAILURE = 'POST_POLICIES_FAILURE';

export const UPDATE_POLICIES_REQUEST = 'UPDATE_POLICIES_REQUEST';
export const UPDATE_POLICIES_SUCCESS = 'UPDATE_POLICIES_SUCCESS';
export const UPDATE_POLICIES_FAILURE = 'UPDATE_POLICIES_FAILURE';

export const DELETE_POLICIES_REQUEST = 'DELETE_POLICIES_REQUEST';
export const DELETE_POLICIES_SUCCESS = 'DELETE_POLICIES_SUCCESS';
export const DELETE_POLICIES_FAILURE = 'DELETE_POLICIES_FAILURE';

export const GET_CLIENT_SETTINGS_REQUEST = 'GET_CLIENT_SETTINGS_REQUEST';
export const GET_CLIENT_SETTINGS_SUCCESS = 'GET_CLIENT_SETTINGS_SUCCESS';
export const GET_CLIENT_SETTINGS_FAILURE = 'GET_CLIENT_SETTINGS_FAILURE';

export const POST_CLIENT_SETTINGS_REQUEST = 'POST_CLIENT_SETTINGS_REQUEST';
export const POST_CLIENT_SETTINGS_SUCCESS = 'POST_CLIENT_SETTINGS_SUCCESS';
export const POST_CLIENT_SETTINGS_FAILURE = 'POST_CLIENT_SETTINGS_FAILURE';

export const UPDATE_CLIENT_SETTINGS_REQUEST = 'UPDATE_CLIENT_SETTINGS_REQUEST';
export const UPDATE_CLIENT_SETTINGS_SUCCESS = 'UPDATE_CLIENT_SETTINGS_SUCCESS';
export const UPDATE_CLIENT_SETTINGS_FAILURE = 'UPDATE_CLIENT_SETTINGS_FAILURE';

export const GET_TEMP_LIVING_PRICE_REQUEST = 'GET_TEMP_LIVING_PRICE_REQUEST';
export const GET_TEMP_LIVING_PRICE_SUCCESS = 'GET_TEMP_LIVING_PRICE_SUCCESS';
export const GET_TEMP_LIVING_PRICE_FAILURE = 'GET_TEMP_LIVING_PRICE_FAILURE';

export const GET_AUTO_SHIPMENT_COST_REQUEST = 'GET_AUTO_SHIPMENT_COST_REQUEST';
export const GET_AUTO_SHIPMENT_COST_SUCCESS = 'GET_AUTO_SHIPMENT_COST_SUCCESS';
export const GET_AUTO_SHIPMENT_COST_FAILURE = 'GET_AUTO_SHIPMENT_COST_FAILURE';

export const GET_PACK_LOAD_MOVE_PRICE_REQUEST = 'GET_PACK_LOAD_MOVE_PRICE_REQUEST';
export const GET_PACK_LOAD_MOVE_PRICE_SUCCESS = 'GET_PACK_LOAD_MOVE_PRICE_SUCCESS';
export const GET_PACK_LOAD_MOVE_PRICE_FAILURE = 'GET_PACK_LOAD_MOVE_PRICE_FAILURE';

export const setEstimations = (estimationList) => {
  return {
    type: SET_NEW_ESTIMATION,
    payload: estimationList,
  };
};

export const getEstimates = () => {
  return {
    [CALL_SELF_SERVE_API]: {
      types: [GET_ESTIMATES_REQUEST, GET_ESTIMATES_SUCCESS, GET_ESTIMATES_FAILURE],
      authenticated: true,
      endpoint: 'estimates',
      method: 'GET',
    },
  };
};

export const postEstimate = (estimateData) => {
  return {
    [CALL_SELF_SERVE_API]: {
      types: [POST_ESTIMATE_REQUEST, POST_ESTIMATE_SUCCESS, POST_ESTIMATE_FAILURE],
      authenticated: true,
      endpoint: 'estimate',
      method: 'POST',
      payload: estimateData,
    },
  };
};

export const updateEstimate = (estimateData) => {
  return {
    [CALL_SELF_SERVE_API]: {
      types: [UPDATE_ESTMATE_REQUEST, UPDATE_ESTIMATE_SUCCESS, UPDATE_ESTIMATE_FAILURE],
      authenticated: true,
      endpoint: 'estimate',
      method: 'PUT',
      payload: estimateData,
    },
  };
};

export const deleteEstimate = (estimateId) => {
  return {
    [CALL_SELF_SERVE_API]: {
      types: [DELETE_ESTIMATE_REQUEST, DELETE_ESTIMATE_SUCCESS, DELETE_ESTIMATE_FAILURE],
      authenticated: true,
      endpoint: `estimate/${estimateId}`,
      method: 'DELETE',
    },
  };
};

export const getHomesalePriceByRegion = (regionName) => {
  return {
    [CALL_SELF_SERVE_API]: {
      types: [GET_HOMESALE_PRICE_REQUEST, GET_HOMESALE_PRICE_SUCCESS, GET_HOMESALE_PRICE_FAILURE],
      authenticated: true,
      endpoint: `homesalePrices/${regionName}`,
      method: 'GET',
    },
  };
};

export const getFlightPrice = (payload) => {
  return {
    [CALL_SELF_SERVE_API]: {
      types: [GET_FLIGHT_PRICE_REQUEST, GET_FLIGHT_PRICE_SUCCESS, GET_FLIGHT_PRICE_FAILURE],
      authenticated: true,
      endpoint: 'flightPrice',
      method: 'POST',
      payload: payload
    },
  };
};

export const getPolicies = () => {
  return {
    [CALL_SELF_SERVE_API]: {
      types: [GET_POLICIES_REQUEST, GET_POLICIES_SUCCESS, GET_POLICIES_FAILURE],
      authenticated: true,
      endpoint: 'estimatorPolicies',
      method: 'GET',
    },
  };
};

export const postPolicy = (policyData) => {
  return {
    [CALL_SELF_SERVE_API]: {
      types: [POST_POLICIES_REQUEST, POST_POLICIES_SUCCESS, POST_POLICIES_FAILURE],
      authenticated: true,
      endpoint: 'estimatorPolicies',
      method: 'POST',
      payload: policyData,
    },
  };
};

export const updatePolicy = (policyData) => {
  return {
    [CALL_SELF_SERVE_API]: {
      types: [UPDATE_POLICIES_REQUEST, UPDATE_POLICIES_SUCCESS, UPDATE_POLICIES_FAILURE],
      authenticated: true,
      endpoint: 'estimatorPolicies',
      method: 'PUT',
      payload: policyData,
    },
  };
};

export const deletePolicy = (policyId) => {
  return {
    [CALL_SELF_SERVE_API]: {
      types: [DELETE_POLICIES_REQUEST, DELETE_POLICIES_SUCCESS, DELETE_POLICIES_FAILURE],
      authenticated: true,
      endpoint: `estimatorPolicies/${policyId}`,
      method: 'DELETE',
    },
  };
};

export const getClientSettings = () => {
  return {
    [CALL_SELF_SERVE_API]: {
      types: [GET_CLIENT_SETTINGS_REQUEST, GET_CLIENT_SETTINGS_SUCCESS, GET_CLIENT_SETTINGS_FAILURE],
      authenticated: true,
      endpoint: 'clientSettings',
      method: 'GET',
    },
  };
};

export const postClientSettings = (clientSettingsData) => {
  return {
    [CALL_SELF_SERVE_API]: {
      types: [POST_CLIENT_SETTINGS_REQUEST, POST_CLIENT_SETTINGS_SUCCESS, POST_CLIENT_SETTINGS_FAILURE],
      authenticated: true,
      endpoint: 'clientSettings',
      method: 'POST',
      payload: clientSettingsData,
    },
  };
};

export const updateClientSettings = (clientSettingsData) => {
  return {
    [CALL_SELF_SERVE_API]: {
      types: [UPDATE_CLIENT_SETTINGS_REQUEST, UPDATE_CLIENT_SETTINGS_SUCCESS, UPDATE_CLIENT_SETTINGS_FAILURE],
      authenticated: true,
      endpoint: 'clientSettings',
      method: 'PUT',
      payload: clientSettingsData,
    },
  };
};

export const getTempLivingPriceByRegion = (state, regionName, rooms) => {
  return {
    [CALL_SELF_SERVE_API]: {
      types: [GET_TEMP_LIVING_PRICE_REQUEST, GET_TEMP_LIVING_PRICE_SUCCESS, GET_TEMP_LIVING_PRICE_FAILURE],
      authenticated: true,
      endpoint: `tempLivingPrices/${state}/${regionName}/${rooms}`,
      method: 'GET',
    },
  };
};

export const getAutoShipmentCost = (mileage) => {
  return {
    [CALL_SELF_SERVE_API]: {
      types: [GET_AUTO_SHIPMENT_COST_REQUEST, GET_AUTO_SHIPMENT_COST_SUCCESS, GET_AUTO_SHIPMENT_COST_FAILURE],
      authenticated: true,
      endpoint: `autoShipment/${mileage}`,
      method: 'GET',
    },
  };
};

export const getPackLoadMovePrice = (miles, homeType, rooms) => {
  return {
    [CALL_SELF_SERVE_API]: {
      types: [GET_PACK_LOAD_MOVE_PRICE_REQUEST, GET_PACK_LOAD_MOVE_PRICE_SUCCESS, GET_PACK_LOAD_MOVE_PRICE_FAILURE],
      authenticated: true,
      endpoint: `hhgPrices/${miles}/${homeType}/${rooms}`,
      method: 'GET',
    },
  };
};
